import { render } from "./FrmSummaryOfDumpsByFamily.vue?vue&type=template&id=12bfbcbb&scoped=true"
import script from "./FrmSummaryOfDumpsByFamily.vue?vue&type=script&lang=js"
export * from "./FrmSummaryOfDumpsByFamily.vue?vue&type=script&lang=js"

import "./FrmSummaryOfDumpsByFamily.vue?vue&type=style&index=0&id=12bfbcbb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bfbcbb"]])

export default __exports__